export function asyncAction(type, action, options = {}) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: type.start, payload: options.startPayload });
      const result = await action(dispatch, getState);
      dispatch({
        type: type.complete,
        payload: options.completePayload
          ? { ...options.completePayload, payload: result }
          : result,
      });
    } catch (e) {
      dispatch({
        type: type.failure,
        payload: options.failurePayload
          ? { ...options.failurePayload, error: e }
          : e,
      });
    }
  };
}
